// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1364":"b811178e40acf691","1454":"92f5f0aa09a35425","2056":"429237e8eb6c8e96","4263":"e20496ca9033ec57","4650":"1f89fe468597f94d","4679":"fb5d2e7b24186d0b","6337":"7e413e571ab32300","7824":"c1d5c5ed9f9289c8","9894":"df6dba095f8d61ef"}[chunkId] + ".js";
};